import createServiceStore from 'shared/utils/createServiceStore.js';
import { API_KEY_SERVICE_KEY } from './apiKeyEnum.js';
import apiKeyService from './apiKeyService.js';
import apiKeyServiceActions from './apiKeyServiceActions.js';
import apiKeyServiceMutations from './apiKeyServiceMutations.js';
import { setLoading } from '../loading/loadingMutationTypes.js';
import { setError } from '../error/errorMutationTypes.js';
import { revokeApiKeyAction } from 'web/apiKey/apiKeyActionTypes';

export default createServiceStore({
  serviceName: API_KEY_SERVICE_KEY,
  service: apiKeyService,
  setLoadingMutation: setLoading,
  setErrorMutation: setError,
  getters: {},
  actions: {
    // Override the generated create so the one-time raw `key` never lingers in the store: we strip
    // it before committing, and return the full object (with `key`) to the caller for a single reveal.
    async [apiKeyServiceActions.create]({ commit }, { data }) {
      commit(setLoading, { key: apiKeyServiceActions.create, value: true });
      commit(setError, { key: apiKeyServiceActions.create, value: null });
      try {
        const created = await apiKeyService.create(data);
        // Strip the one-time raw secret before it touches the store; return it to the caller below.
        const sanitized = { ...created };
        delete sanitized.key;
        commit(apiKeyServiceMutations.update, {
          id: sanitized.id,
          payload: sanitized,
        });
        return created;
      } catch (err) {
        commit(setError, { key: apiKeyServiceActions.create, value: err });
        throw err;
      } finally {
        commit(setLoading, { key: apiKeyServiceActions.create, value: false });
      }
    },
    async [revokeApiKeyAction]({ commit }, { apiKeyId }) {
      commit(setLoading, { key: revokeApiKeyAction, value: true });
      commit(setError, { key: revokeApiKeyAction, value: null });
      try {
        await apiKeyService.revoke(apiKeyId);
        // Backend lists active keys only; drop the revoked key from local state so it disappears.
        commit(apiKeyServiceMutations.remove, apiKeyId);
      } catch (err) {
        commit(setError, { key: revokeApiKeyAction, value: err });
        throw err;
      } finally {
        commit(setLoading, { key: revokeApiKeyAction, value: false });
      }
    },
  },
});
